export { default } from "./GameContent"
